(function () {
  var BAR_ID = 'lv-welcome-offer';
  var CLOSE_ID = 'lv-welcome-offer-close';
  var STORAGE_KEY = 'lv_welcome_offer_closed_v1';
  var SHOWN_KEY = 'lv_welcome_offer_shown_v1';
  var SCROLL_TRIGGER = 120;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    var bar = document.getElementById(BAR_ID);
    if (!bar) return;

    if (sessionStorage.getItem(SHOWN_KEY) === '1') return;
    if (localStorage.getItem(STORAGE_KEY) === '1') return;

    var shown = false;

    function showBar() {
      if (shown) return;
      shown = true;

      bar.hidden = false;
      requestAnimationFrame(function () {
        bar.classList.add('is-visible');
      });

      sessionStorage.setItem(SHOWN_KEY, '1');
      window.removeEventListener('scroll', onScroll, { passive: true });
    }

    function closeBar() {
      bar.classList.remove('is-visible');
      localStorage.setItem(STORAGE_KEY, '1');

      setTimeout(function () {
        bar.hidden = true;
      }, 320);
    }

    function onScroll() {
      if (window.scrollY > SCROLL_TRIGGER) {
        showBar();
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });

    var closeBtn = document.getElementById(CLOSE_ID);
    if (closeBtn) {
      closeBtn.addEventListener('click', closeBar);
    }
  });
})();